import { render, staticRenderFns } from "./MsspBrandProtection.vue?vue&type=template&id=0063b20d&scoped=true"
import script from "./MsspBrandProtection.vue?vue&type=script&lang=js"
export * from "./MsspBrandProtection.vue?vue&type=script&lang=js"
import style0 from "./MsspBrandProtection.vue?vue&type=style&index=0&id=0063b20d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063b20d",
  null
  
)

export default component.exports